export default __webpack_public_path__ + "static/media/kreis.1dcc5344.png";